import React from "react";
import {Route, Routes} from "react-router-dom";
import Reg from "./Reg";
import MyRegistrations from "./MyRegistrations";

export default () => {
    return <Routes>
        <Route path={"/"} element={<MyRegistrations/>}/>
        <Route path={"/:id/*"} element={<Reg/>}/>
    </Routes>
}
